// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6f2b3853","455":"f5d3f1c9","977":"6d1c8084"}[chunkId] + ".chunk.js";
};